import { Component, OnInit, NgZone } from '@angular/core';
import { WgisService } from '../wgis/wgis.service';
import { Router } from '@angular/router';
import { Angulartics2 } from 'angulartics2';
import { WMAIApiService, AppInformationService, Word } from '../core';
import { TranslateService } from '@ngx-translate/core';
import * as foo from '../core/models/functions-cordova';
import { error, element } from 'protractor';
import { SuiModalService, ModalSize } from 'ng2-semantic-ui';
import { SimpleModal, ConfirmModal } from '../core/templates';
import { Subscription } from 'rxjs';
import { MapCacheData } from '../core/models/mapcache';
declare let $: any;
declare let cordova;
@Component({
  selector: 'app-maps',
  templateUrl: './maps.component.html'
})
export class MapsComponent implements OnInit {
  loading = false;
  maps: Word[] = [];
  savedMaps: { id: number, value: boolean }[] = [];
  loadingMaps = [];
  subscriptionDownload: Subscription;

  constructor(
    private wgisservice: WgisService,
    private wmaiservice: WMAIApiService,
    private translateService: TranslateService,
    private appservice: AppInformationService,
    private modalService: SuiModalService,
    private zone: NgZone,
    private router: Router,
    private angulartics2: Angulartics2
  ) {
    this.wgisservice.setMapInvisible();
    this.subscriptionDownload = this.appservice.changeDownloadingMaps.subscribe(value => {
      this.checkMaps();
    });
  }

  ngOnInit() {
    this.loading = true;
    this.getMaps();
  }

  ngOnDestroy() {
    if (this.subscriptionDownload != null) {
      this.subscriptionDownload.unsubscribe();
    }
  }
  /**
   * Restituisce le mappe deisponibili al download e controlla quelle presenti in locale
   */
  getMaps() {
    this.wmaiservice.wordsByLocale(this.translateService.getDefaultLang(), "map").subscribe(data => {
      this.maps = data;
      this.checkMaps();
    });
  }
  /**
   * Controlla le mappe presenti in locale
   */
  checkMaps() {
    const promises: Promise<{ id: number, value: boolean }>[] = [];
    this.maps.forEach(map => {
      promises.push(MapCacheData.isRegisteredIdP(map.id));
      // promises.push( foo.checkMap(map.id));
    });
    Promise.all(promises).then(values => {
      // console.log(values);
      this.savedMaps = values;
      this.loading = false;
    }).catch(values => {
      console.log("Errore lettura", values);
      this.loading = false;
    });
  }
  /**
   * Controlla se una mappa in base al suo id sia presente tra quelle salvate in locale
   * @param id della mappa
   * @returns la mappa se presente
   */
  isSaved(id: number) {
    return this.savedMaps.find(element => element.id == id && element.value);
  }
  /**
   * Controlla se una mappa è in fase di download
   * @param id della mappa
   * @returns {boolean}
   */
  checkLoadingMaps(id: number) {
    if (this.appservice.checkLoadingMaps(id).length > 0) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * Scarica una mappa in locale
   * @param map oggetto che contiene id e val(URL) della mappa
   */
  onDownloadFile(map: { id: number, cat: string, val: string }) {
    if (this.appservice.getCurrentConnectionStatus()) {
      this.appservice.setLoadingMaps(map.id);
      this.wmaiservice.getResouceDownload(map.val).subscribe((data) => {
        if(data && data.url){
          foo.downloadMap(map, data.url, this.router).then(value => {
            this.zone.run(() => {
              this.appservice.removeLoadingMaps(map.id);
              this.appservice.downloadComplete(map.id);
              this.checkMaps();
            })
          }).catch(error => {
            this.zone.run(() => {
              this.appservice.removeLoadingMaps(map.id);
              this.checkMaps();
              alert(error);
            })
          });
        } else {
          this.appservice.removeLoadingMaps(map.id);
          let titlec: string = this.translateService.instant('modal.maps.download.title');
          let contentc: string = this.translateService.instant('modal.maps.download.error_resouce');
          this.modalService
            .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
            .onApprove(() => {
            })
            .onDeny(() => {
            });
          }
      })
      
    } else {
      let titlec: string = this.translateService.instant('modal.maps.download.title');
      let contentc: string = this.translateService.instant('modal.maps.download.connectionproblem');
      this.modalService
        .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
        .onApprove(() => {
        })
        .onDeny(() => {
        });
    }
  }
  /**
   * Cancella una mappa scaricata in locale
   * @param map ogetto cge contiene id e val(URL) della mappa
   */
  onRemoveFile(map) {
    this.appservice.setLoadingMaps(map.id);
    this.wgisservice.removeCache(map.id).then(value => {
      foo.deleteMap(map.id).then(value => {
        if (value) {
          // console.log("eliminato");
          this.appservice.removeLoadingMaps(map.id);
          MapCacheData.deregisterId(map.id);
          this.appservice.downloadComplete(map.id);
          this.checkMaps();
        } else {
          console.log("non esiste");
        }
      }).catch(error => {
        console.log(error);
        this.checkMaps();
      });
    }).catch(error => {
      console.log(error);
      this.checkMaps();
    });
    
  }
}